import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache,
  type NormalizedCacheObject
} from '@apollo/client'
import { ErrorLink } from '@apollo/client/link/error'
import { tap } from 'rxjs'
import * as AbsintheSocket from '@absinthe/socket'
import { Socket as PhoenixSocket } from 'phoenix'

import config from '../config'
import { createAbsintheSocketLink, hasSubscription } from './absinthe-socket-link'
import {
  loginUrlWithExpiredMessage,
  resetSessionTimer,
  shouldRedirectToLogin
} from './session-timer'

const errorLink = new ErrorLink(({ error }) => {
  if (shouldRedirectToLogin(error)) {
    window.location.href = loginUrlWithExpiredMessage()
  }
})

const httpLink = new HttpLink({
  uri: config.GRAPHQL_API_URL,
  credentials: 'include'
})

const absintheSocketLink = createAbsintheSocketLink(
  AbsintheSocket.create(
    new PhoenixSocket(config.GRAPHQL_WS_URL, {
      transportOptions: {
        websocket: {
          withCredentials: true
        }
      }
    } as any)
  )
)

const sessionTimerLink = new ApolloLink((operation, forward) =>
  forward(operation).pipe(tap(() => resetSessionTimer()))
)

const link = ApolloLink.from([
  sessionTimerLink,
  errorLink,
  ApolloLink.split(
    (operation) => hasSubscription(operation.query),
    absintheSocketLink,
    httpLink
  )
])

let apolloClient: ApolloClient | null = null

export const getClient = () => apolloClient!

const client = (initialState?: NormalizedCacheObject) => {
  apolloClient = new ApolloClient({
    link,
    cache: new InMemoryCache().restore(initialState || {})
  })
  return apolloClient
}

export const newClient = client({})
